import { render } from "./CreativePreview.vue?vue&type=template&id=644fa4aa&scoped=true"
import script from "./CreativePreview.vue?vue&type=script&lang=js"
export * from "./CreativePreview.vue?vue&type=script&lang=js"

import "./CreativePreview.vue?vue&type=style&index=0&id=644fa4aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644fa4aa"]])

export default __exports__